import React from 'react';
import AllPropertyMetrics from './_all_property_metrics';
import PropertyListings from './_property_listings';
import CompanyPropertyDetails from './_company_property_details';

export default function PropertySettingsPage() {
  return (
    <>
      <div className="px-4 py-4 w-full">
        <AllPropertyMetrics />

        <div className="gap-6 grid grid-cols-1 md:grid-cols-3 mt-6">
          <div className="col-span-1">
            <CompanyPropertyDetails />
          </div>
          <div className="col-span-1 md:col-span-2">
            <PropertyListings />
          </div>
        </div>
      </div>
    </>
  );
}